import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmedValidator } from '../confirmed.validator';
import { UtilitaService } from '../services/utilita.service';
 import { Md5 } from "md5-typescript"; 
import { MatDialog } from '@angular/material/dialog';
import { MessaggioOkComponent } from './messaggio-ok/messaggio-ok.component';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-profilo',
  templateUrl: './profilo.component.html',
  styleUrls: ['./profilo.component.css']
})
export class ProfiloComponent {
  frmInserimento!: FormGroup;
  frmLogin!: FormGroup;
  frmNuovaPassword!: FormGroup;
  lstAtenei: any;
  lstDipartimenti: any;
  lstRuolo: any;
  lstReferente: any;
  lstSettoreScientifico: any;

  codiceclientenew: number = -1;
  objclientenew: any;
    lstTipoNewsletter: any;




  constructor(private fb: FormBuilder,
    private srvUtilita: UtilitaService,
    private dialog: MatDialog, private router: Router,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.frmInserimento = this.fb.group({ //nuovo profilo //tab1
      idUtentiProfilo: [null],
      Cognome: [null],
      Nome: [null],
      Email: [null, [Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}')]],
      Password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!.@$%^&*-]).{8,}$')
        ]
      ],
      ConfermaPassword: ['', [Validators.required]],
      idAteneo: [null],
      idDipartimento: [null],
      NewsLetterStrutturato: [null],
      NewsLetterNonStrutturato: [null],
      NewsLetterGenerica: [null],
      idRuolo: [null],
      idReferenteTipologia: [-1],
      idSettoreScientifico: [2],
      Telefono: [null],
      idTipoNewsletter: [1],
      CodiceFiscale: [null, [Validators.pattern('^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$')]],
    }, {
      validators: [
        ConfirmedValidator('Password', 'ConfermaPassword')
      ]
    })

    this.getAtenei();
    this.getDipartimenti('-1');
    this.getRuolo();
    this.getReferente();
    this.getSettoreScientifico();
    this.getNewsletter();

    this.frmLogin = this.fb.group({ //login //tab2
      Email: [null],
      Password: [null]
    })


    this.frmNuovaPassword = this.fb.group({ //nuova password //tab3
      Email: [null],
    })

   
  }

  getAtenei() {
    this.srvUtilita.getLista('Utenti/GetAteneiLista').subscribe((res: any) => {
      this.lstAtenei = res

     // console.log('res', res)
    }, (err: any) => {
      })


  }

  getDipartimenti(idAteneo: any) {
  //  console.log('idateneo', idAteneo);
    this.srvUtilita.getLista('Utenti/GetDipartimentiLista?idAteneo=' + idAteneo).subscribe((res: any) => {
      this.lstDipartimenti = res

     // console.log("this.lstDipartimenti:", res);
    
    }, (err: any) => {
    })
  }


  /*
  getRuoloa() {
    this.srvUtilita.getLista('Utenti/GetUtentiProfiloRuoloLista').subscribe((res: any) => {
      this.lstRuolo = res
      console.log("this.lstRuolo:", this.lstRuolo);
    }, (err: any) => {
    })
  }
  */
  getRuolo() {
    this.srvUtilita.getLista('Utenti/GetRuoliStrutturatoLista').subscribe((res: any) => {
      this.lstRuolo = res
 //    console.log("this.lstRuolo:", this.lstRuolo);
    }, (err: any) => {
    })
  }

  getReferente() {
    this.srvUtilita.getLista('Utenti/GetUtentiProfiloReferenteTipologiaLista').subscribe((res: any) => {
      this.lstReferente = res
      //console.log("this.lstReferente:", this.lstReferente);
    }, (err: any) => {
    })
  }

  getSettoreScientifico() {
    this.srvUtilita.getLista('Utenti/GetSettoreScientificoLista').subscribe((res: any) => {
      this.lstSettoreScientifico = res
      //console.log("this.lstSettoreScientifico:", this.lstSettoreScientifico);
    }, (err: any) => {
    })
  }

  getNewsletter() {
    this.srvUtilita.getLista('TipoNewsletter/GetTipoNewsletter').subscribe((res: any) => {
      this.lstTipoNewsletter = res
      //  console.log('res', res)
    })
  }

  btnCreaNuovoProfilo() { //btnsalva
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    if (objInserimento.NewsLetterStrutturato == true) {
      objInserimento.NewsLetterStrutturato = 1
    } else {
      objInserimento.NewsLetterStrutturato = 0
    }

    if (objInserimento.NewsLetterNonStrutturato == true) {
      objInserimento.NewsLetterNonStrutturato = 1
    } else { objInserimento.NewsLetterNonStrutturato = 0 }

    if (objInserimento.NewsLetterGenerica == true) {
      objInserimento.NewsLetterGenerica = 1
    } else { objInserimento.NewsLetterGenerica = 0 }

    let sPassword: string = "";
    sPassword = Md5.init(objInserimento.Password);

    const obj = {
      idUtentiProfilo: 0,
      Cognome: objInserimento.Cognome,
      Nome: objInserimento.Nome,
      Email: objInserimento.Email,
      Password: sPassword,
      idAteneo: objInserimento.idAteneo,
      idDipartimento: objInserimento.idDipartimento,
      NewsLetterStrutturato: objInserimento.NewsLetterStrutturato,
      NewsLetterNonStrutturato: objInserimento.NewsLetterNonStrutturato,
      NewsLetterGenerica: objInserimento.NewsLetterGenerica,
      idRuolo: objInserimento.idRuolo,
      idReferenteTipologia: objInserimento.idReferenteTipologia,
      idSettoreScientifico: objInserimento.idSettoreScientifico,
      Telefono: objInserimento.Telefono,
      CodiceFiscale: objInserimento.CodiceFiscale,
      isVerificato: 0,
      idTipoNewsletter: objInserimento.idTipoNewsletter
    }

 

    
  //public int VerificaEmailCodiceFiscale(string sEmail , string sCodiceFiscale)
     
    this.srvUtilita.getObj('Utenti/VerificaEmailCodiceFiscale?sEmail=' + objInserimento.Email+'&sCodiceFiscale='+objInserimento.CodiceFiscale).subscribe((res: any) => {

      if (res == 1) {
        this.srvUtilita.postObj('Utenti/PostCreaNuovoProfilo', obj).subscribe((res: any) => {
          this.showMessage('Operazione avvenuta correttamente.', 'OK')
      
           
          let dialogRef: MatDialogRef<any> = this.dialog.open(MessaggioOkComponent, {
              width: '720px',
              disableClose: false,
              data: {  }
            })
            dialogRef.afterClosed()
              .subscribe((res: any) => {
               
              })
         
         
        }, (err: any) => {
          this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
        //  console.log(err.error.Message, 'ERRORE');
        })
      }
      if (res == 2) {
        this.showMessage('Errore: Codice FISCALE e EMAIL già presente ', 'OK')
      }
      if (res == 3) {
        this.showMessage('Errore: EMAIL già presente ', 'OK')
      }
      if (res == 4) {
        this.showMessage('Errore: Codice FISCALE già presente ', 'OK')
      }
    }, (err: any) => {
      this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
     // console.log(err.error.Message, 'ERRORE');
    })
  
    
  }
   



  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }

}
